import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";


/** Composants */
import ElementAssociation from './ElementAssociation.js'

/** Api */
import { apiListe } from '../api.js';

const FormAssociation = styled.div`
margin: 10px;
padding: 10px 5px;
float:left;
background-color: darkgray;
width: 80%;
`

const Titre = styled.span`
margin:0 auto;
`


const Association = (param) => {
    const {typeElement, id, typeElementAAssocier} = param

    const [liste, setListe] = useState([])
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {
        apiListe(typeElementAAssocier, '*')
        .then(res => {
            setListe(res.reponse)
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setLoading(false)
            setErreur(true)
        })
    }, [typeElementAAssocier])

    return (
        <FormAssociation>
            <Titre>Association avec le type "{typeElementAAssocier}" </Titre>
            { !loading  && !erreur && liste
            && <ElementAssociation
                key={id}
                id={id}
                typeElement={typeElement}
                typeElementAAssocier={typeElementAAssocier}
                liste={liste}/>}
            {loading  && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
            {erreur  && <h3>J'ai rencontré un problème...</h3> }
        </FormAssociation>
    )
}
export default Association